import React from 'react';
import ModalVideo from 'react-modal-video';
import '../../../node_modules/react-modal-video/scss/modal-video.scss';

class Banner extends React.Component {
    state = {
        isOpen: false
    }

    openModal = () => {
        this.setState({isOpen: true})
    }

    render(){
        let modalStyles = {overlay: {zIndex: 100000000000000}};
        return (
            <div>
            <div id="home" className="uk-banner main-banner item-bg1">
                <div className="d-table">
                    <div className="d-table-cell">
                        <div className="uk-container">
                            <div className="main-banner-content">
                                <h1>Building Intelligent <br /> Software for a <br /> Smarter World</h1>
                                <p>AznTech delivers end-to-end software development and AI solutions — from scalable web platforms to machine learning integrations. We partner with businesses to turn ambitious ideas into production-ready technology.</p>
                                <a href="#contact" className="uk-button uk-button-default">Get Started</a>
                                {/* Watch Video button removed — placeholder video ID */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ModalVideo
                style={modalStyles}
                channel='youtube'
                isOpen={this.state.isOpen}
                videoId='bk7McNUjWgw'
                onClose={() => this.setState({isOpen: false})}
            />
            </div>
        );
    }
}

export default Banner;
